import { gql } from '@apollo/client';

const BUCKET_FRAGMENT = gql`
  fragment BucketFragment on Bucket {
    title
    gigCount
    description
    color
  }
`;

const GROUPED_GIG_BUCKET_FRAGMENT = gql`
  fragment GroupedGigBucketFragment on Bucket {
    title
    gigCount
    gigGroupCount
    description
    color
  }
`;

const BUCKET_WITH_FILTERED_GIGS_COUNT_FRAGMENT = gql`
  fragment BucketWithFilteredGigsCountFragment on Bucket {
    id
    ...BucketFragment
    filteredGigCount(filter: $filter)
    gigs(filter: $filter) {
      id
    }
  }
`;

const BUCKET_WITH_FILTERED_GIG_GROUP_COUNT_FRAGMENT = gql`
  fragment BucketWithFilteredGigGroupCountFragment on Bucket {
    id
    ...GroupedGigBucketFragment
    filteredGigCount(filter: $filter)
    filteredGigGroupCount(filter: $filter)
    groupedGigs(filter: $filter) {
      isDriverAssigned
      gigCount
      driver {
        id
        ...DriverBasicDetailsFragment
      }
      lastEvent {
        ...GigEventFragment
      }
      gigs {
        id
      }
    }
  }
`;

const BUCKET_WITH_GIGS_FRAGMENT = gql`
  fragment BucketWithGigsFragment on Bucket {
    id
    ...BucketFragment
    gigs(
      order: $order
      pageNumber: $pageNumber
      recordsPerPage: $recordsPerPage
      filter: $filter
    ) {
      id
      ...GigBasicDetailsFragment
      consolidation {
        id
        ...GigConsolidationDetailsFragment
      }
    }
  }
`;

export const BucketFragments = [
  BUCKET_FRAGMENT,
  GROUPED_GIG_BUCKET_FRAGMENT,
  BUCKET_WITH_GIGS_FRAGMENT,
  BUCKET_WITH_FILTERED_GIGS_COUNT_FRAGMENT,
  BUCKET_WITH_FILTERED_GIG_GROUP_COUNT_FRAGMENT
];
